export enum ConfidenceLevel {
    NONE = "NONE",
    BRONZE = "BRONZE",
    SILVER = "SILVER",
    GOLD = "GOLD"
}

const BRONZE = 0.7;
const SILVER = 0.75;
const GOLD = 0.8;

export function confidenceLevel(confidence: number): ConfidenceLevel {
    if (confidence < BRONZE) {
        return ConfidenceLevel.NONE;
    } else if (confidence < SILVER) {
        return ConfidenceLevel.BRONZE;
    } else if (confidence < GOLD) {
        return ConfidenceLevel.SILVER;
    } else {
        return ConfidenceLevel.GOLD;
    }
}
